var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.082 5.539h5.4v20.923h-5.4zM19.053 5.539h5.4v20.923h-5.4z"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjguMDgyMDMiIHk9IjUuNTM5MDYiIHdpZHRoPSI1LjQiIGhlaWdodD0iMjAuOTIzMyIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cmVjdCB4PSIxOS4wNTM1IiB5PSI1LjUzOTA2IiB3aWR0aD0iNS40IiBoZWlnaHQ9IjIwLjkyMzMiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { Svg32 as ReactComponent };